import { render, staticRenderFns } from "./AppBtn.vue?vue&type=template&id=63e248a1&scoped=true&"
import script from "./AppBtn.vue?vue&type=script&lang=ts&"
export * from "./AppBtn.vue?vue&type=script&lang=ts&"
import style0 from "./AppBtn.vue?vue&type=style&index=0&id=63e248a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e248a1",
  null
  
)

export default component.exports